import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import makeStylesFn from './styles';
import CustomChip from './CustomChip';
var useStyles = makeStyles(makeStylesFn);
var DeleteChip = function DeleteChip(_ref) {
  var onDeleteAll = _ref.onDeleteAll,
    clearAllLabel = _ref.clearAllLabel,
    ariaLabel = _ref.ariaLabel;
  var classes = useStyles();
  return React.createElement(CustomChip, {
    label: clearAllLabel,
    ariaLabel: ariaLabel,
    chipClasses: cx(classes.mainChip, classes.chip),
    onDelete: onDeleteAll,
    iconClasses: classes.icon,
    labelClasses: cx(classes.spaceLabel, classes.formatLabel)
  });
};
DeleteChip.propTypes = process.env.NODE_ENV !== "production" ? {
  onDeleteAll: PropTypes.func,
  ariaLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  clearAllLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
} : {};
export default DeleteChip;